(function () {

  // ── Fallback image replacement ──────────────────────────────────────────

  function shuffleArray(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  var shuffled = [];
  var idx = 0;

  function replaceFallbackImages() {
    var images = window.jdgmFallbackImages || [];
    if (!images.length) return;

    if (!shuffled.length) shuffled = shuffleArray(images);

    document.querySelectorAll('.jdgm-card.jdgm-media-card > img:not([data-jdgm-replaced])').forEach(function (img) {
      if (!img.src.includes('judgeme.imgix.net')) {
        img.setAttribute('data-jdgm-replaced', 'true');
        img.src = shuffled[idx % shuffled.length];
        idx++;
      }
    });
  }

  var imageObserver = new MutationObserver(function () {
    replaceFallbackImages();
  });

  imageObserver.observe(document.body, { childList: true, subtree: true });

  replaceFallbackImages();
  setTimeout(replaceFallbackImages, 300);
  setTimeout(replaceFallbackImages, 1000);
  setTimeout(replaceFallbackImages, 2500);

  document.addEventListener('judgeme:all_widgets:loaded', replaceFallbackImages);


  // ── Subtitle injection ──────────────────────────────────────────────────

  function injectSubtitle() {
    var subtitle = window.jdgmSubtitle;
    if (!subtitle) return;

    var title = document.querySelector('.jdgm-title');
    if (!title || title.dataset.subtitleInjected) return;

    title.dataset.subtitleInjected = 'true';
    var span = document.createElement('span');
    span.className = 'jdgm-subtitle';
    span.innerHTML = subtitle;
    title.insertAdjacentElement('afterend', span);
  }

  var subtitleObserver = new MutationObserver(function () {
    injectSubtitle();
    if (document.querySelector('.jdgm-title[data-subtitle-injected]')) {
      subtitleObserver.disconnect();
    }
  });

  subtitleObserver.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', injectSubtitle);

})();